import React, { useState } from 'react';
import RepairEstimator from '../components/RepairEstimator';
import SEO from '../components/SEO';

const RepairEstimatePage = () => {
  const [savedEstimates, setSavedEstimates] = useState([]);

  const handleSaveEstimate = (estimate) => {
    setSavedEstimates([...savedEstimates, { ...estimate, id: Date.now() }]);
  };

  const handleDeleteEstimate = (id) => {
    setSavedEstimates(savedEstimates.filter(est => est.id !== id));
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-cream to-white pt-24">
      <SEO 
        title="Jewelry Repair Calculator | Get Instant Estimates | Master Jewelers GA"
        description="Get instant jewelry repair estimates with our online calculator. Ring sizing, watch repair, stone setting, and more. While-you-wait service available in Cumming and Alpharetta, GA."
        keywords="jewelry repair calculator, ring sizing cost, watch repair estimate, jewelry repair price, instant jewelry quote Georgia"
      />
      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-6 py-8">
        
        {/* Saved Estimates */}
        {savedEstimates.length > 0 && (
          <div className="mb-8 bg-white rounded-lg shadow-lg p-6">
            <h3 className="font-playfair text-2xl text-charcoal mb-4">Your Saved Estimates</h3>
            <div className="space-y-3">
              {savedEstimates.map((estimate) => (
                <div key={estimate.id} className="flex justify-between items-center p-4 bg-gold-50 rounded-lg">
                  <div>
                    <span className="font-montserrat text-sm font-semibold">{estimate.service}</span>
                    <span className="mx-2 text-charcoal/40">•</span>
                    <span className="font-cormorant text-charcoal/70">{estimate.branch}</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="font-playfair text-xl text-gold-600">{estimate.price}</span>
                    <button
                      onClick={() => handleDeleteEstimate(estimate.id)}
                      className="text-red-500 hover:text-red-700"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        
        <RepairEstimator onSaveEstimate={handleSaveEstimate} />
      </div>

    </div>
  );
};

export default RepairEstimatePage;
